export default __webpack_public_path__ + "static/media/category_grey.7077f32a.svg";